import React from 'react';

import { InProgress } from '../in-progress/InProgress.view';

import './ConnectMessages.scss';

export const PollToConnectView: React.FC = () => (
  <>
    <h2 className="connect-message-title">Provisioning completed successfully!</h2>
    <p>Please allow a few minutes for the subscription to connect.</p>
    <div style={{ display: 'flex', justifyContent: 'center' }}>
      <InProgress size="medium" />
    </div>
  </>
);
